import type { GameStatistics } from "../storage/statistics_storage.js";
import { formatShortDuration } from "../common/common_funcs.js";

export function heartCountText( stats: GameStatistics, now_ms: number ): string
{
  return stats.infinite_hearts_until > now_ms ? "\u221E" : String( stats.hearts );
}

/**
 * Countdown of a timed reward window: m:ss for the last hour, "2г 5хв" style
 * above it. Shared by infinite hearts and the timed no-ads badge.
 */
export function rewardWindowTimerText( until_ms: number, now_ms: number ): string
{
  const left_ms = Math.max( 0, until_ms - now_ms );
  if ( left_ms >= 3_600_000 )
    return formatShortDuration( left_ms );
  const seconds_left = Math.ceil( left_ms / 1000 );
  const m = Math.floor( seconds_left / 60 );
  const s = seconds_left % 60;
  return `${m}:${String( s ).padStart( 2, "0" )}`;
}

/**
 * While infinite hearts are active the badge counts down the window instead
 * of the next-heart regen.
 */
export function heartTimerText( stats: GameStatistics, now_ms: number ): string
{
  if ( stats.infinite_hearts_until > now_ms )
    return rewardWindowTimerText( stats.infinite_hearts_until, now_ms );

  if ( stats.hearts >= stats.max_hearts || stats.next_heart_at <= 0 )
    return "MAX";

  const seconds_left = Math.max( 0, Math.ceil( ( stats.next_heart_at - now_ms ) / 1000 ) );
  const m = Math.floor( seconds_left / 60 );
  const s = seconds_left % 60;
  return `${m}:${String( s ).padStart( 2, "0" )}`;
}
